import http from './index';

export const loginAuthAPI = data => http.post('auth/login', data);

export const meAuthAPI = () => http.get('auth/me');
